import React from 'react';
import {Button, ImageUploader} from 'components';
import {store} from 'store';
import css from './custom-image.module.scss';

export function CustomImage({ id }) {
  return (
    <label title="Change image" className={css.container}>
      <ImageUploader data-id={id} data-type="goal" onComplete={attachImage} />
      <Button tagName="span" className={['tiny', 'secondary', 'filled']} icon="edit-image">Change</Button>
    </label>
  );
}

function attachImage(file) {
  store.dispatch({
    type: 'FILES_UPLOAD',
    file,
  });
}
